import Services from '../../pages/Services/Main';
import ServicesDeleted from '../../pages/Services/Deleted';
import ServicesRates from '../../pages/Services/Rates';
import ServicesHide from '../../pages/Services/Hide';

import { uuid } from '../../utils/helper';

export default [
  {
    name: 'Services',
    link: '/services',
    id: uuid(),
    component: Services,
    exact: true,
    react: true,
  },
  {
    name: 'Services rates',
    link: '/services/mass-edit',
    id: uuid(),
    component: ServicesRates,
    exact: true,
    react: true,
  },
  {
    name: 'Services deleted',
    link: '/services/deleted',
    id: uuid(),
    component: ServicesDeleted,
    exact: true,
    react: true,
  },
  {
    name: 'Services hide',
    link: '/services/hide',
    id: uuid(),
    secondaryLinks: [
      '/services/hide/service',
    ],
    component: ServicesHide,
    exact: false,
    react: true,
  },
];
